import { Container, Content } from './Emissions.styled';
import { useTranslation } from 'react-i18next';
import { LeafIcon } from 'refactored/ui/icons';
import PropTypes from 'prop-types';
import { useMemo } from 'react';

const convertGramsToKg = (amount) => {
  if (!amount) return '0';
  return (amount / 1000).toFixed(2);
};

const Emissions = ({ show, emissionsData }) => {
  const { t } = useTranslation('OrdersOrderDetail');

  const { noAccurateData, amount, savings } = useMemo(() => {
    const { so_co2_consumed: co2Consumed, so_co2_saved: co2Saved } =
      emissionsData || {};
    return {
      noAccurateData: !co2Consumed || !co2Saved,
      amount: convertGramsToKg(co2Consumed),
      savings: convertGramsToKg(co2Saved),
    };
  }, [emissionsData]);

  if (!show) return null;

  return (
    <Container noData={noAccurateData} data-testid="emissions">
      <span className="icon">
        <LeafIcon />
      </span>
      {noAccurateData ? (
        <span data-testid="emissions-no-data">{t('emissions_no_data')}</span>
      ) : (
        <Content data-testid="emissions-info">
          <strong>{t('emissions_title')}</strong>
          <p>{t('emissions_emitted', { amount })}</p>
          <p>{t('emissions_savings', { savings })}</p>
        </Content>
      )}
    </Container>
  );
};

Emissions.propTypes = {
  show: PropTypes.bool,
  emissionsData: PropTypes.object,
};

Emissions.defaultProps = {
  show: false,
};

export default Emissions;
